import FormPage from "./FormPage.jsx"

export default FormPage;